import { render, staticRenderFns } from "./NewTrianglePropertyEditor.vue?vue&type=template&id=72866bc1&scoped=true&"
import script from "./NewTrianglePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewTrianglePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72866bc1",
  null
  
)

export default component.exports